const urls = {
  configuration: "/dashboard/configuration",
  index: "/dashboard",
};

export default urls;
